import script from "./Preamble.vue?vue&type=script&lang=js"
export * from "./Preamble.vue?vue&type=script&lang=js"

import "./Preamble.vue?vue&type=style&index=0&id=80df3428&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80df3428"]])

export default __exports__